import { Options } from '../options.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { UserTypeEnum } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

export interface AbtestApiConfig {
  appId: string;
  baseUrl: string;
}

export const ABTEST_API_CONFIG = new InjectionToken<AbtestApiConfig>('ABTEST_API_CONFIG');

@Injectable({
  providedIn: 'root',
})
export class AbTestWebservice {
  readonly #httpClient = inject(HttpClient);
  readonly #abtestApiConfig = inject(ABTEST_API_CONFIG);
  readonly #baseUrl = this.#abtestApiConfig.baseUrl;
  readonly #appId = this.#abtestApiConfig.appId;

  getVersion(campaignId: string, userType: UserTypeEnum, userId: string): Observable<{ value: string }> {
    return this.#httpClient.get<{ value: string }>(
      `${this.#baseUrl}/v1/product/${this.#appId}/campaign/${campaignId}/${userType}/${userId}`,
      { withCredentials: true }
    );
  }

  /**
   * Check if a user has a variant been assigned a variant for an AB test campaign
   *
   * Returns 404: when no campaign was found
   * @param campaignId
   * @param userType
   * @param userId
   */
  hasVariant(campaignId: string, userType: UserTypeEnum, userId: string): Observable<{ hasVariant: boolean }> {
    return this.#httpClient.get<{ hasVariant: boolean }>(
      `${this.#baseUrl}/v1/product/${this.#appId}/campaign/${campaignId}/${userType}/${userId}/has-variant`,
      { withCredentials: true }
    );
  }

  patchVersion(
    campaignId: string,
    userType: UserTypeEnum,
    userId: string,
    variant: string,
    options?: Options
  ): Observable<void> {
    return this.#httpClient.patch<void>(
      `${this.#baseUrl}/v1/update-variant/product/${this.#appId}/campaign/${campaignId}/${userType}/${userId}`,
      variant,
      options
    );
  }
}
